// extracted by mini-css-extract-plugin
export default {"global-layout":"Global_global-layout__Lci6e","global-layout__body":"Global_global-layout__body__QF0i9","global-layout__body--body":"Global_global-layout__body--body__C4cuN"};